/* eslint-disable jsx-a11y/label-has-for */
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Text from '@clearscore/rainbow.text';
import toTitleCase from '@clearscore/normalize.title-case';

import styles from './label.css';
import { themes } from './constants';

const Label = ({ children, description, htmlFor, isLegend, theme, dataId }) => {
    const themeClass = styles[`isTheme${toTitleCase(theme)}`];
    const wrapperClass = cx(styles.wrapper, themeClass);
    const descriptionClass = cx(styles.description, themeClass);

    const Tag = isLegend ? 'LEGEND' : 'LABEL';
    return (
        <div className={wrapperClass} data-qa="label" data-id={dataId}>
            <Text {...Text.presets.H3} tag={Text.tags[Tag]} htmlFor={htmlFor}>
                {children}
            </Text>
            <If condition={description}>
                <div data-qa="description" className={descriptionClass}>
                    <Text {...Text.presets.BODY2}>{description}</Text>
                </div>
            </If>
        </div>
    );
};

export const Legend = ({ ...props }) => <Label {...props} isLegend />;

Label.propTypes = {
    children: PropTypes.node.isRequired,
    description: PropTypes.string,
    htmlFor: PropTypes.string,
    isLegend: PropTypes.bool,
    theme: PropTypes.oneOf(Object.values(themes)),
    dataId: PropTypes.string,
};

Label.defaultProps = {
    description: '',
    htmlFor: '',
    isLegend: false,
    theme: themes.LIGHT,
    dataId: undefined,
};

Label.themes = themes;

export default Label;
